// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__16RRU","legacyBtn":"MutateMid_legacyBtn__3JcMs"};